import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequest = (data: any) => {
  return {
    id: data?.id,
    instrument: data?.instrument,
    packageName: data?.packageName,
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const updatePackageToInstrument = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPack2InstUpdate),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { updatePackageToInstrument }
